import './Welcome.css';
import React from "react";
import Footer from './Footer.js';
import welcome from '../assets/images/welcome.png'
import welcomeOuter from '../assets/images/welcomeOuter.png'

function Welcome() {
    return (
        <div className="">
                            <div className="welcomeImageDiv">
                    <img className="welcomeCircleImage" src={welcome} alt="" />
                    <img className="welcomeCircleImage" src={welcomeOuter} alt="" />
                    <p className="welcomeCircleText three"> you can’t achieve your goals if
                         <br></br>you’re running on empty.
                         <br></br>with <span className="bold">one of fourteen</span>, build a 
                         <br></br>personalized biweekly system that
                         <br></br>incorporates your individual 
                         <br></br>productivity, wellness, and
                         <br></br>responsibilities.</p>
                    <div className="welcomeExpandingBlurCircle"></div>
            </div>
                <div className="welcomeDivText">
                    <p className="four"> welcome to </p>
                    <p className="eight"> one of fourteen </p>
                    <p className="two"> a productivity system that
                        <br></br>prioritizes your mental and physical health</p>
                    <p className="three margin"> the quality of your daily routine
                        <br></br>determines the quality of your life -
                        <br></br>are you satisfied with yours?</p>
                    <div className="row margin">
                    <a className="welcomeButton" href="/about">
                        <p className="three"> learn more </p>
                    </a>
                    <a className="welcomeButton" href="/app">
                        <p className="three"> log in </p>
                    </a>
                    </div>

                </div>
            <Footer />
        </div>
    )
}

export default Welcome;